'use client';

import _slicedToArray from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/regenerator/index.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { subscribeToQuery } from 'datocms-listen';
import { useState } from 'react';
import { useDeepCompareEffectNoCheck as useDeepCompareEffect } from 'use-deep-compare-effect';
export function useQuerySubscription(options) {
  var enabled = options.enabled,
    initialData = options.initialData,
    other = __rest(options, ["enabled", "initialData"]);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = useState(enabled ? 'connecting' : 'closed'),
    _useState6 = _slicedToArray(_useState5, 2),
    status = _useState6[0],
    setStatus = _useState6[1];
  var subscribeToQueryOptions = other;
  useDeepCompareEffect(function () {
    if (enabled === false) {
      setStatus('closed');
      return function () {
        // we don't have to perform any uninstall
      };
    }
    var unsubscribe;
    function subscribe() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return subscribeToQuery(Object.assign(Object.assign({}, subscribeToQueryOptions), {
                onStatusChange: function onStatusChange(status) {
                  setStatus(status);
                },
                onUpdate: function onUpdate(updateData) {
                  setError(null);
                  setData(updateData.response.data);
                },
                onChannelError: function onChannelError(errorData) {
                  setData(null);
                  setError(errorData);
                }
              }));
            case 2:
              unsubscribe = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
    subscribe();
    return function () {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [subscribeToQueryOptions]);
  return {
    error: error,
    status: status,
    data: data || initialData
  };
}